'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthService = function () {
  function AuthService($http, $state, SessionService) {
    'ngInject';

    _classCallCheck(this, AuthService);

    Object.assign(this, { $http: $http, $state: $state, SessionService: SessionService });
  }

  _createClass(AuthService, [{
    key: 'getUserInfo',
    value: function getUserInfo() {
      return this.$http.get('/api/account/user_info');
    }
  }, {
    key: 'login',
    value: function login(credentials) {
      var _this = this;

      var data = 'grant_type=password&username=' + encodeURIComponent(credentials.userName) + '&password=' + encodeURIComponent(credentials.password);

      return this.$http.post('/token', data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (r) {
        _this.SessionService.authToken = r.data.access_token;

        return _this.$http.get('/api/account/user_info');
      }).then(function (r) {
        _this.SessionService.user = r.data;
      });
    }
  }, {
    key: 'logout',
    value: function logout() {
      this.$state.go('login');
      this.SessionService.destroy();
    }
  }, {
    key: 'forgotPassword',
    value: function forgotPassword(userName) {
      return this.$http.post('/api/account/forgot_password?userName=' + userName);
    }
  }, {
    key: 'getAccessLevels',
    value: function getAccessLevels() {
      var accessLevels = [{
        id: 1,
        desc: 'Level 1'
      }, {
        id: 2,
        desc: 'Level 2'
      }, {
        id: 3,
        desc: 'Level 3'
      }];

      return accessLevels;
    }
  }, {
    key: 'isLoggedIn',
    get: function get() {
      return this.SessionService.user != null && this.SessionService.authToken != null;
    }
  }, {
    key: 'isSysAdmin',
    get: function get() {
      if (!this.SessionService.user) {
        return false;
      }

      return this.SessionService.user.UserType === 'SystemAdministrator';
    }
  }, {
    key: 'isCompanyAdmin',
    get: function get() {
      if (!this.SessionService.user) {
        return false;
      }

      return this.SessionService.user.UserType === 'Member' && this.SessionService.user.LevelOfAccess === 3;
    }
  }, {
    key: 'isRegulator',
    get: function get() {
      if (!this.SessionService.user) {
        return false;
      }

      return this.SessionService.user.UserType === 'Regulator';
    }
  }, {
    key: 'isRegulatorAdmin',
    get: function get() {
      return this.isRegulator && this.SessionService.user.LevelOfAccess === 3;
    }
  }, {
    key: 'isUser',
    get: function get() {
      if (!this.SessionService.user) {
        return false;
      }

      return this.SessionService.user.UserType === 'Member' && this.SessionService.user.LevelOfAccess === 1;
    }
  }]);

  return AuthService;
}();

exports.default = AuthService;


// WEBPACK FOOTER //
// ./services/auth.service.js